/**************************************************
 * Nombre:       Seccion_Videos_Empresarial
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {theme} from "../../Tema";
import Tarjeta_Videos_Empresarial from "../Tarjetas/Tarjeta_Videos_Empresarial";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";
import {useParams} from "react-router-dom";


const Seccion_Videos_Empresarial = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [videos, setVideos] = useState([]);
    const [idEscogido, setIdEscogido] = useState('');


    useEffect(() => {

        obtenerCol('videos').then((dox) => {
            setVideos(dox.data);
        })

    }, [])

    useEffect(() => {

        if (parms && parms.id) {
            setIdEscogido(parms.id);
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
                onLoad={() => {

                    if (idEscogido) {
                        scrolearAComponente(idEscogido)
                    }

                }
                }
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        Videos Empresariales
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1.5 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Encuentra aquí videos pensados para inspirar, aprender y compartir con tu
                                        comunidad, ampliando el mensaje del Team Tufiño.
                                    </Typography>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 8, px: sCell ? 0 : 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        {videos.map((it, index) => (
                            <Grid container size={{xs: 12, sm: 6, md: 9}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Videos_Empresarial escogida={idEscogido}   item={it}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Videos_Empresarial


const videos = [
    {
        nombre: 'Documento Uno',
    },
    {
        nombre: 'Documento Dos',
    },
    {
        nombre: 'Documento Tres',
    },
    {
        nombre: 'Documento Cuatro',
    },
]